// extracted by mini-css-extract-plugin
export default {"wrapper":"Home-module__wrapper___62XMO"};